import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-info-nav-bar',
  templateUrl: './info-nav-bar.component.html',
  styleUrls: ['./info-nav-bar.component.css']
})
export class InfoNavBarComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/info-nav-bar/info-nav-bar.component.ts